export default __webpack_public_path__ + "static/media/ImporterIcon.1499eb7a.svg";